import type { Maybe } from '@adornis/base/utilTypes.js';
import { Arg, Entity, Field, Mutation } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { DateTime } from 'luxon';

/**
 * @entity SoftgardenImportRecord
 */
@Entity()
export class SoftgardenImportRecord extends MongoEntity {
  public static override _class = 'SoftgardenImportRecord';
  public static override _collectionName = 'softgarden-cache';

  @Field(() => DateTime, { default: v => v ?? DateTime.now() })
  public createdAt: Maybe<DateTime>;

  // If this field holds a value it will be deleted at that date.
  @Field(() => DateTime)
  public markedForDeletionAtDate: Maybe<DateTime>;

  @Field(() => String)
  public key: Maybe<string>;

  @Field(() => String)
  public softgardenContent: Maybe<string>;

  @Mutation(() => Boolean)
  public static setRemoveDateOnSoftgardenRecordByID(@Arg('recordID', () => String) recordID: string) {
    return async () => {
      const coll = await getCollection(this._class);
      const result = await coll.updateOne(
        { key: recordID },
        { $set: { markedForDeletionAtDate: DateTime.now().plus({ days: 7 }).toJSDate() } },
      );
      return !!result;
    };
  }
}
